import React from 'react'
import withIcon from '@/components/withIcon'

const IconSpa = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 9.04297H4C2.89543 9.04297 2 9.9384 2 11.043V18.043C2 19.1475 2.89543 20.043 4 20.043H20C21.1046 20.043 22 19.1475 22 18.043V11.043C22 9.9384 21.1046 9.04297 20 9.04297Z"
        fill="#C6D5D8"
      />
      <path
        d="M22 12.043V11.043C22 10.5125 21.7893 10.0038 21.4142 9.62875C21.0391 9.25368 20.5304 9.04297 20 9.04297H4C3.46957 9.04297 2.96086 9.25368 2.58579 9.62875C2.21071 10.0038 2 10.5125 2 11.043V12.043H22Z"
        fill="#C6D5D8"
      />
      <path
        d="M20 9H4C2.89543 9 2 9.89543 2 11V18C2 19.1046 2.89543 20 4 20H20C21.1046 20 22 19.1046 22 18V11C22 9.89543 21.1046 9 20 9Z"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.5 9.04294L11.294 4.24994C11.4815 4.06247 11.7358 3.95715 12.001 3.95715C12.2662 3.95715 12.5205 4.06247 12.708 4.24994L17.5 9.04294"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.001 17.043V12.043"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 12.043H11.5C11.8978 12.043 12.2794 12.201 12.5607 12.4823C12.842 12.7636 13 13.1451 13 13.543C13 13.9408 12.842 14.3223 12.5607 14.6036C12.2794 14.8849 11.8978 15.043 11.5 15.043H11"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 12.043H8C7.73478 12.043 7.48043 12.1483 7.29289 12.3359C7.10536 12.5234 7 12.7778 7 13.043C7 14.543 9 14.543 9 16.043C9 16.3082 8.89464 16.5625 8.70711 16.7501C8.51957 16.9376 8.26522 17.043 8 17.043H7"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15 17.043V13.043C15 12.7778 15.1054 12.5234 15.2929 12.3359C15.4804 12.1483 15.7348 12.043 16 12.043C16.2652 12.043 16.5196 12.1483 16.7071 12.3359C16.8946 12.5234 17 12.7778 17 13.043V17.043"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.001 15.043H17.001"
        stroke="#00303E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default withIcon(IconSpa)
